import { ConstantPool } from "@angular/compiler";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalAlertService } from "src/app/global-alert.service";
import { GlobalService } from "src/app/global.service";
import * as moment from "moment";
import Swal from "sweetalert2";

@Component({
  selector: "app-historico-datos",
  templateUrl: "./historico-datos.component.html",
  styleUrls: ["./historico-datos.component.css"],
})
export class HistoricoDatosComponent implements OnInit {
  constructor(
    public global: GlobalService,
    public ruta: Router,
    public alerta: GlobalAlertService,
    public spinner: NgxSpinnerService
  ) {
    this.global.initData();
    const vari = localStorage.getItem("USERDATALIWA");
    this.USERDATALIWA = vari.split(",");
    // console.log('USERDATALIWA', this.USERDATALIWA);
    this.global.UserName = this.USERDATALIWA[3];
    this.global.Id_Usuario = this.USERDATALIWA[0];
  }
  // CUERPO DE LA QUERY
  idTicket;
  Evidence: boolean = false;
  descriptionBenefit;
  typePQRS = "prueba";
  id_Proyecto;
  NombreProyecto: String;
  NombreSeccional: String;
  id_Seccional;
  id_Beneficiario;
  provBenefit;
  // CUERPO DE LA QUERY
  datosBeneficiario;
  USERDATALIWA;
  valorMenu1;
  valorSubMenu1: String = '-';
  valorSubMenu2: String = '-';
  valorSubMenu3: String = '-';
  clientClass;
  codigo;

  banderaCrearTicket: boolean = false;

  types = [
    { type: "Comprobantes" },
    { type: "Novedad Solucion" },
    { type: "Pagos" },
    { type: "Suspension" },
    { type: "Pqrs" },
    { type: "llamada outbound" },
  ];
  //  SUB MENUS 1 APARTIR DEL PRIMER CASO
  opcionPqrs: boolean = false;
  typesSubMenu1Pqrs = [
    { type: "Tipo de Tramite" },
    { type: "Tipo de Respuesta" },
    { type: "Facturacion" },
    { type: "Prestacion" },
  ];
  opcionComprobantes: boolean = false;
  typesSubMenu1Comprobantes = [
    { type: "Pagos" },
    { type: "disponibilidad de servicio" },
    { type: "Estado de cuenta mes actaul" },
    { type: "Estado de cuenta mes anterios" },
    { type: "Estado de cuenta mes post anterior" },
  ];
  opcionNovedad: boolean = false;
  typesSubMenu1Novedad = [{ type: "Daño" }, { type: "Traslado" }, { type: "Acceso restringido" }];
  opcionPagos: boolean = false;
  typesSubMenu1Pagos = [
    { type: "Pago no reflejado" },
    { type: "Usuario no habilitado" },
    { type: "Recaudacion sin servicio" },
    { type: "Acuerdo de pago" },
    { type: "Solicitud aplicacion fecha de pago" },
  ];
  opcionSuspension: boolean = false;
  typesSubMenu1Suspension = [{ type: "Reconexcion Fallida" }];
  //  SUB MENUS 2 APARTIR DEL SEGUNDO CASO
  opcionSubMenu2Facturacion: boolean = false;
  typesSubMenu2Facturacion = [
    { type: "Inconformidad con el aforo" },
    {
      type: "Inconformidad con la medicion del consumo o produccion facturado",
    },
    { type: "Cobros inoportunos" },
    { type: "cobro por servicios no prestados" },
    { type: "datos generales incorrectos" },
    { type: "cobro multiple y/o acumulado" },
    { type: "entrega inoportuna o no entrega de factura" },
    { type: "cobros por conexión, reconexion, reinstalacion" },
    { type: "incorformidad con el cambio o con el cobro del medidor" },
    {
      type: "cobro de cargos relacionados con intereses de mora, refinanciacion, cartera o acuerdos de pago",
    },
    { type: "subsidios y contribuciones" },
    {
      type: "cobro de otros bienes o servicios en la factura no autorizados por el usuario",
    },
    { type: "incumplimiento o negacion del acuerdo o suspension del servicio" },
    { type: "estrato incorrecto" },
    { type: "clase de uso incorrecto (industrial, comercial, oficial, otros)" },
    { type: "tarifa incorrecta" },
    { type: "costos por promedio" },
    { type: "cobro de consumo registrado por medidor de otro promedio" },
    {
      type: "suscriptor que efectua el pago pero este no es aplicado por la empresa en la facturacion",
    },
    { type: "solicitud de rompimiento de solidaridad" },
    { type: "cobro de revisiones" },
    { type: "inconformidad por desviacion significativa" },
    { type: "cobro por recuperacion de consumos" },
    { type: "inconformidad por la normalizacion del servicio" },
    { type: "cobro por reconexion no autorizada porla empresa" },
    { type: "negacion de la solicitud de suspension" },
  ];

  opcionSubMenu2llamadaOutbound: boolean = false;
  typesSubMenu2llamadaOutbound = [
    { type: "no contesta" },
    { type: "ocupado" },
    { type: "telefono dañado" },
    { type: "buzon de Mensajes" },
    { type: "llamada de Bienvenida" },
    { type: "equivocado" },
  ];

  opcionSubMenu2TipoTramite: boolean = false;
  typesSubMenu2TipoTramite = [
    { type: "Reclamacion" },
    { type: "Queja" },
    { type: "Recursos de reposicion" },
    { type: "Recurso de reposicion y subsidio de apelacion" },
  ];
  opcionSubMenu2Prestacion: boolean = false;
  typesSubMenu2Prestacion = [
    { type: "Interrupciones en la prestacion del servicio" },
    {
      type: "Variaciones en las caracteristicas del suministro o prestacion del servicio",
    },
    { type: "No atencion de condiciones de seguridad o riesgo" },
    { type: "Terminacion del contrato" },
    {
      type: "Suspension o corte del servicio sin previo aviso o si causa aparente",
    },
    { type: "Quejas administrativas" },
    { type: "Estado de la infraestructura" },
    { type: "Fallas en la conexión del servicio" },
    { type: "No conexión del servicio" },
    { type: "Hurto parte UC" },
    { type: "Hurto solucion" },
    { type: "Cambio de titularidad" },
    { type: "Desistimiento" },
    { type: "Reposición" },
    { type: "Garantía" },
  ];
  opcionSubMenu2TipoRespuesta: boolean = false;
  typesSubMenu2TipoRespuesta = [
    { type: "Accede" },
    { type: "Accede parcialmente" },
    { type: "No accede" },
    { type: "Confirma" },
    { type: "Modifica" },
    { type: "Revoca" },
    { type: "Rechaza" },
    { type: "Translada competencias" },
    { type: "Pendiente de respuesta" },
    { type: "Sin respuesta" },
    { type: "Archiva" },
  ];
  opcionSubMenu2Pagos: boolean = false;
  typesSubMenu2Pagos = [
    // este se aplica a varios casos por raxones internas
    { type: "Envio comprobante" },
  ];
  opcionSubMenu2Danos: boolean = false;
  typesSubMenu2Danos = [
    { type: "% Carga Bateria" },
    { type: "Apertura gabinete" },
    { type: "Datos Tension" },
    { type: "Gestor" },
    { type: "otro" },
    { type: "Panel con daño fisico" },
    { type: "sin servicio" },
    { type: "Tarjeta datos" },
    { type: "Tecnico (CRM)" },
  ];
  opcionSubMenu2acceso: boolean = false;
  typesSubMenu2acceso = [
    { type: "Orden público" },
    { type: "Orden Social" }
  ];
  optioSubMenu2SolicitudAplicaciones: Boolean = false;
  typesSubMenu2SolicitudAplicaciones = [
    { type: "Capacidad de pago" },
    { type: "Olvido" },
    { type: "Reclamacion pendiente" },
    { type: "No recibio factura" },
  ];
  opcionSubMenu2ReconexionFallida: boolean = false;
  typesSubMenu2ReconexionFallida = [{ type: "Agendamiento visita" }];
  //  SUB MENUS 3 APARTIR DEL tercer CASO
  opcionSubMenu3TipoTramite: boolean = false;
  typesSubMenu3TipoTramite = [{ type: "Facturacion" }, { type: "Prestacion" }];
  opcionSubMenu3TipoRespuesta: boolean = false;
  typesSubMenu3Respuesta = [
    {
      type: "Notificación Personal (Artículos 67 y 68 de la Ley 1437 de 2011)",
    },
    { type: "Notificación por Aviso (Artículo 69 de la Ley 1437 de 2011)." },
    {
      type: "Notificación por Conducta Concluyente (Artículo 72 de la Ley 1437 de2011)",
    },
    { type: "No Requiere Notificación" },
    { type: "Pendiente o en trámite de notificación" },
  ];
  opcionSubMenu3Gestor: boolean = false;
  typesSubMenu3Gestor = [{ type: "Alarma Sonora" }, { type: "Sin senal" }];
  opcionSubMenu3Panel: boolean = false;
  typesSubMenu3Panel = [{ type: "Agendamiento visita" }];
  opcionSubMenu3Tarjeta = false;
  typesSubMenu3Tarjeta = [
    { type: "Daño fisico" },
    { type: "No permite lectura" },
    { type: "Perdida" },
  ];
  ngOnInit(): void {
    this.clientClass = this.global.CLIENTDATALIWA[8];
    this.datosBeneficiario = this.global.informacionBeneficiario
      ? this.global.informacionBeneficiario
      : JSON.parse(window.localStorage.getItem("informacion beneficiario"));
    console.log(this.datosBeneficiario, 'echiohhcohcohcohcohoo')
    if (this.global.banderaModificaionTicket) {
      this.spinner.show()
      // this.banderaCrearTicket = true
      // console.log(this.global.Id_Ticket.length > 2 ,'yteuietyueteyuteut')
      // const pdata2 = { option: "insertar2", texto: `select * from db_liwa.Tickets_New where Id_Tickets = '${this.global.Id_Ticket}';` };
      //         this.global.consultar(pdata2, (err2, response2) => {
      //           this.valorMenu1 = response2[0][6]
      //           this.handleChangeSubMenu1()
      //           this.valorSubMenu1 = response2[0][7]
      //           this.handleChangeSubMenu2()
      //           this.valorSubMenu2 = response2[0][8]
      //           this.handleChangeSubMenu3()
      //           this.valorSubMenu3 = response2[0][9]
      //           this.handleChangeDescriction()
      //           this.descriptionBenefit = response2[0][10]
      //           this.id_Seccional = response2[0][3]
      //           this.id_Proyecto = response2[0][2]
      //           this.id_Beneficiario = response2[0][5]
      //           console.log('eeses2255',this.id_Proyecto,this.id_Seccional)
      //           const pdata9 = { option: 'insertar2', texto: `SELECT Nombre,(SELECT Nombre FROM db_liwa.Seccionales WHERE id_Seccional = ${this.id_Seccional}) FROM db_liwa.tipoProyecto WHERE id_tipoProyecto = ${this.id_Proyecto};` };
      //           this.global.consultar(pdata9,async (err9, response9) => {
      //             this.NombreProyecto = await response9[0][0];
      //             this.NombreSeccional = await response9[0][1];
      //             console.log('eeses22',this.NombreProyecto,
      //             this.NombreSeccional,)
      //           })
      this.spinner.hide()
      // })

    }
    console.log('eeses2255', this.datosBeneficiario[0][3], this.datosBeneficiario[0][4])
    const pdata9 = { option: 'insertar2', texto: `SELECT Nombre,(SELECT Nombre FROM db_liwa.Seccionales WHERE id_Seccional = ${this.datosBeneficiario[0][4]}) FROM db_liwa.tipoProyecto WHERE id_tipoProyecto = ${this.datosBeneficiario[0][3]};` };
    this.global.consultar(pdata9, async (err9, response9) => {
      this.NombreProyecto = await response9[0][0];
      this.NombreSeccional = await response9[0][1];
      console.log('eeses33', this.NombreProyecto,
        this.NombreSeccional,)
    })
  }

  handleChangeSubMenu1() {
    //  console.log('mis vales',this.valorMenu1 )

    this.banderaCrearTicket = false;

    this.opcionSubMenu2ReconexionFallida = false;
    this.opcionSubMenu2Pagos = false;
    this.opcionSubMenu2Danos = false;
    this.opcionSubMenu2acceso = false;
    this.optioSubMenu2SolicitudAplicaciones = false;

    this.opcionSubMenu2TipoTramite = false;
    this.opcionSubMenu2TipoRespuesta = false;
    this.opcionSubMenu2ReconexionFallida = false;
    this.opcionSubMenu2Pagos = false;
    this.opcionSubMenu2Danos = false;
    this.opcionSubMenu2acceso = false;
    this.optioSubMenu2SolicitudAplicaciones = false;

    this.opcionSubMenu3Gestor = false;
    this.opcionSubMenu3Panel = false;
    this.opcionSubMenu3Tarjeta = false;
    this.opcionSubMenu3TipoRespuesta = false;
    this.opcionSubMenu3TipoTramite = false;
    this.valorSubMenu1 = "-";
    this.valorSubMenu2 = "-";
    this.valorSubMenu3 = "-";

    switch (this.valorMenu1) {
      case "Comprobantes":
        this.opcionComprobantes = true;
        this.opcionNovedad = false;
        this.opcionPagos = false;
        this.opcionSuspension = false;
        this.opcionPqrs = false;
        this.opcionSubMenu2llamadaOutbound = false;
        break;
      case "Novedad Solucion":
        this.opcionNovedad = true;
        this.opcionComprobantes = false;
        this.opcionPagos = false;
        this.opcionSuspension = false;
        this.opcionPqrs = false;
        this.opcionSubMenu2llamadaOutbound = false;
        break;
      case "Pagos":
        this.opcionPagos = true;
        this.opcionComprobantes = false;
        this.opcionNovedad = false;
        this.opcionSuspension = false;
        this.opcionPqrs = false;
        this.opcionSubMenu2llamadaOutbound = false;
        break;
      case "Suspension":
        this.opcionSuspension = true;
        this.opcionComprobantes = false;
        this.opcionNovedad = false;
        this.opcionPagos = false;
        this.opcionPqrs = false;
        this.opcionSubMenu2llamadaOutbound = false;
        break;
      case "Pqrs":
        this.opcionPqrs = true;
        this.opcionSuspension = false;
        this.opcionComprobantes = false;
        this.opcionNovedad = false;
        this.opcionPagos = false;
        this.opcionSubMenu2llamadaOutbound = false;
        break;
      case "llamada outbound":
        this.opcionSubMenu2llamadaOutbound = true;
        this.opcionPqrs = false;
        this.opcionSuspension = false;
        this.opcionComprobantes = false;
        this.opcionNovedad = false;
        this.opcionPagos = false;
        break;
      default:
        this.opcionSubMenu2llamadaOutbound = false;
        this.opcionComprobantes = false;
        this.opcionNovedad = false;
        this.opcionPagos = false;
        this.opcionSuspension = false;

        break;
    }
  }
  handleChangeSubMenu2() {
    console.log('mis vales 2 ', this.valorSubMenu1)
    this.banderaCrearTicket = false;
    this.valorSubMenu2 = "";

    this.opcionSubMenu2ReconexionFallida = false;
    this.opcionSubMenu2Pagos = false;
    this.opcionSubMenu2Danos = false;
    this.opcionSubMenu2acceso = false;
    this.optioSubMenu2SolicitudAplicaciones = false;


    this.opcionSubMenu2TipoTramite = false;
    this.opcionSubMenu2TipoRespuesta = false;
    this.opcionSubMenu2ReconexionFallida = false;
    this.opcionSubMenu2Pagos = false;
    this.opcionSubMenu2Danos = false;
    this.opcionSubMenu2acceso = false;
    this.optioSubMenu2SolicitudAplicaciones = false;
    this.opcionSubMenu2Prestacion = false;
    this.opcionSubMenu2Facturacion = false;
    this.opcionSubMenu3Gestor = false;
    this.opcionSubMenu3Panel = false;
    this.opcionSubMenu3Tarjeta = false;
    this.opcionSubMenu3TipoRespuesta = false;
    this.opcionSubMenu3TipoTramite = false;

    switch (this.valorSubMenu1) {
      case "Pagos":
        this.opcionSubMenu2Pagos = true;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "disponibilidad de servicio":
        this.opcionSubMenu2Pagos = true;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Reconexcion Fallida":
        this.opcionSubMenu2ReconexionFallida = true;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Estado de cuenta mes actaul":
        this.opcionSubMenu2Pagos = true;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Estado de cuenta mes anterios":
        this.opcionSubMenu2Pagos = true;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Estado de cuenta mes post anterior":
        this.opcionSubMenu2Pagos = true;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Daño":
        this.opcionSubMenu2Danos = true;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Traslado":
        this.opcionSubMenu2Danos = true;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Acceso restringido":
        this.opcionSubMenu2acceso = true;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2Pagos = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Solicitud aplicacion fecha de pago":
        this.optioSubMenu2SolicitudAplicaciones = true;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Tipo de Tramite":
        this.opcionSubMenu2TipoTramite = true;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Tipo de Respuesta":
        this.opcionSubMenu2TipoRespuesta = true;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Facturacion":
        this.opcionSubMenu2Facturacion = true;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2Prestacion = false;
        break;
      case "Prestacion":
        this.opcionSubMenu2Prestacion = true;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        this.opcionSubMenu2TipoTramite = false;
        break;
      case "Pago no reflejado":
      case "Usuario no habilitado":
      case "Recaudacion sin servicio":
      case "Acuerdo de pago":
      case "no contesta":
      case "ocupado":
      case "telefono dañado":
      case "buzon de Mensajes":
      case "equivocado":
      case "llamada de Bienvenida":
        this.banderaCrearTicket = true;
        break;
      default:
        this.opcionSubMenu2Prestacion = false;
        this.opcionSubMenu2Facturacion = false;
        this.opcionSubMenu2TipoTramite = false;
        this.opcionSubMenu2TipoRespuesta = false;
        this.opcionSubMenu2ReconexionFallida = false;
        this.opcionSubMenu2Pagos = false;
        this.opcionSubMenu2Danos = false;
        this.opcionSubMenu2acceso = false;
        this.optioSubMenu2SolicitudAplicaciones = false;
        break;
    }
  }
  handleChangeSubMenu3() {
    switch (this.valorSubMenu2) {
      case "Gestor":
        this.opcionSubMenu3Gestor = true;
        this.opcionSubMenu3Panel = false;
        this.opcionSubMenu3Tarjeta = false;
        this.opcionSubMenu3TipoRespuesta = false;
        this.opcionSubMenu3TipoTramite = false;
        break;
      case "Panel con daño fisico":
      case "otro":
      case "sin servicio":
        this.opcionSubMenu3Panel = true;
        this.opcionSubMenu3Gestor = false;
        this.opcionSubMenu3Tarjeta = false;
        this.opcionSubMenu3TipoRespuesta = false;
        this.opcionSubMenu3TipoTramite = false;
        break;
      case "Tarjeta datos":
        this.opcionSubMenu3Tarjeta = true;
        this.opcionSubMenu3Gestor = false;
        this.opcionSubMenu3Panel = false;
        this.opcionSubMenu3TipoRespuesta = false;
        this.opcionSubMenu3TipoTramite = false;
        break;
      case "Reclamacion":
        this.opcionSubMenu3TipoTramite = true;
        this.opcionSubMenu3TipoRespuesta = false;
        this.opcionSubMenu3Gestor = false;
        this.opcionSubMenu3Panel = false;
        this.opcionSubMenu3Tarjeta = false;
        break;
      case "Queja":
        this.opcionSubMenu3TipoTramite = true;
        this.opcionSubMenu3TipoRespuesta = false;
        this.opcionSubMenu3Gestor = false;
        this.opcionSubMenu3Panel = false;
        this.opcionSubMenu3Tarjeta = false;
        break;
      case "Recursos de reposicion":
        this.opcionSubMenu3TipoTramite = true;
        this.opcionSubMenu3TipoRespuesta = false;
        this.opcionSubMenu3Gestor = false;
        this.opcionSubMenu3Panel = false;
        this.opcionSubMenu3Tarjeta = false;
        break;
      case "Recurso de reposicion y subsidio de apelacion":
        this.opcionSubMenu3TipoTramite = true;
        this.opcionSubMenu3TipoRespuesta = false;
        this.opcionSubMenu3Gestor = false;
        this.opcionSubMenu3Panel = false;
        this.opcionSubMenu3Tarjeta = false;
        break;
      case "Accede":
      case "Accede parcialmente":
      case "No accede":
      case "Confirma":
      case "Modifica":
      case "Revoca":
      case "Rechaza":
      case "Translada competencias":
      case "Pendiente de respuesta":
      case "Sin respuesta":
      case "Archiva":
        this.opcionSubMenu3TipoRespuesta = true;
        this.opcionSubMenu3TipoTramite = false;
        this.opcionSubMenu3Gestor = false;
        this.opcionSubMenu3Panel = false;
        this.opcionSubMenu3Tarjeta = false;
        break;
      case "Envio comprobante":
      case "Tecnico (CRM)":
      case "Inconformidad con el aforo":
        this.codigo = 101;
        this.banderaCrearTicket = true;
        break
      case "Inconformidad con la medicion del consumo o produccion facturado":
        this.codigo = 102;
        this.banderaCrearTicket = true;
        break
      case "Cobros inoportunos":
        this.codigo = 103;
        this.banderaCrearTicket = true;
        break
      case "cobro por servicios no prestados":
        this.codigo = 105;
        this.banderaCrearTicket = true;
        break
      case "datos generales incorrectos":
        this.codigo = 106;
        this.banderaCrearTicket = true;
        break
      case "cobro multiple y/o acumulado":
        this.codigo = 107;
        this.banderaCrearTicket = true;
        break
      case "entrega inoportuna o no entrega de factura":
        this.codigo = 108;
        this.banderaCrearTicket = true;
        break
      case "cobros por conexión, reconexion, reinstalacion":
        this.codigo = 109;
        this.banderaCrearTicket = true;
        break
      case "incorformidad con el cambio o con el cobro del medidor":
        this.codigo = 110;
        this.banderaCrearTicket = true;
        break
      case "cobro de cargos relacionados con intereses de mora, refinanciacion, cartera o acuerdos de pago":
        this.codigo = 111;
        this.banderaCrearTicket = true;
        break
      case "subsidios y contribuciones":
        this.codigo = 112;
        this.banderaCrearTicket = true;
        break
      case "cobro de otros bienes o servicios en la factura no autorizados por el usuario":
        this.codigo = 113;
        this.banderaCrearTicket = true;
        break
      case "incumplimiento o negacion del acuerdo o suspension del servicio":
        this.codigo = 115;
        this.banderaCrearTicket = true;
        break
      case "estrato incorrecto":
        this.codigo = 117;
        this.banderaCrearTicket = true;
        break
      case "clase de uso incorrecto (industrial, comercial, oficial, otros)":
        this.codigo = 118;
        this.banderaCrearTicket = true;
        break
      case "tarifa incorrecta":
        this.codigo = 119;
        this.banderaCrearTicket = true;
        break
      case "costos por promedio":
        this.codigo = 120;
        this.banderaCrearTicket = true;
        break
      case "cobro de consumo registrado por medidor de otro promedio":
        this.codigo = 121;
        this.banderaCrearTicket = true;
        break
      case "suscriptor que efectua el pago pero este no es aplicado por la empresa en la facturacion":
        this.codigo = 122;
        this.banderaCrearTicket = true;
        break
      case "solicitud de rompimiento de solidaridad":
        this.codigo = 123;
        this.banderaCrearTicket = true;
        break
      case "cobro de revisiones":
        this.codigo = 124;
        this.banderaCrearTicket = true;
        break
      case "inconformidad por desviacion significativa":
        this.codigo = 127;
        this.banderaCrearTicket = true;
        break
      case "cobro por recuperacion de consumos":
        this.codigo = 129;
        this.banderaCrearTicket = true;
        break
      case "inconformidad por la normalizacion del servicio":
        this.codigo = 131;
        this.banderaCrearTicket = true;
        break
      case "cobro por reconexion no autorizada porla empresa":
        this.codigo = 133;
        this.banderaCrearTicket = true;
        break
      case "negacion de la solicitud de suspension":
        this.codigo = 301;
        this.banderaCrearTicket = true;
        break
      case "Interrupciones en la prestacion del servicio":
        this.codigo = 303;
        this.banderaCrearTicket = true;
        break
      case "Variaciones en las caracteristicas del suministro o prestacion del servicio":
        this.codigo = 304;
        this.banderaCrearTicket = true;
        break
      case "No atencion de condiciones de seguridad o riesgo":
        this.codigo = 306;
        this.banderaCrearTicket = true;
        break
      case "Terminacion del contrato":
        this.codigo = 308;
        this.banderaCrearTicket = true;
        break
      case "Suspension o corte del servicio sin previo aviso o si causa aparente":
        this.codigo = 309;
        this.banderaCrearTicket = true;
        break
      case "Quejas administrativas":
        this.codigo = 315;
        this.banderaCrearTicket = true;
        break
      case "Estado de la infraestructura":
        this.codigo = 316;
        this.banderaCrearTicket = true;
        break
      case "Fallas en la conexión del servicio":
        this.codigo = 401;
        this.banderaCrearTicket = true;
        break
      case "No conexión del servicio":
        this.codigo = 402;
        this.banderaCrearTicket = true;
        break
      case "Hurto parte UC":
        this.banderaCrearTicket = true;
        break
      case "Hurto solucion":
        this.banderaCrearTicket = true;
        break
      case "Cambio de titularidad":
        this.banderaCrearTicket = true;
        break
      case "Desistimiento":
        this.banderaCrearTicket = true;
        break
      case "Reposición":
        this.banderaCrearTicket = true;
        break
      case "Garantía":
        this.banderaCrearTicket = true;
        break
      case "Orden Social":
        this.banderaCrearTicket = true;
        break
      case "Orden público":
        this.banderaCrearTicket = true;
        break
      case "% Carga Bateria":
      case "Apertura gabinete":
      case "Datos Tension":

      case "Capacidad de pago":
      case "Olvido":
      case "TReclamacion pendiente":
      case "No recibio factura":
      case "Agendamiento visita":
        this.banderaCrearTicket = true;
        break;
      default:
        // this.banderaCrearTicket = true
        this.opcionSubMenu3TipoRespuesta = false;
        this.opcionSubMenu3TipoTramite = false;
        this.opcionSubMenu3Gestor = false;
        this.opcionSubMenu3Panel = false;
        this.opcionSubMenu3Tarjeta = false;
        break;
    }
  }
  handleChangeDescriction() {
    this.valorSubMenu3 ? (this.banderaCrearTicket = true) : console.log();
  }
  atras() {
    if (this.global.banderaModificaionTicket) {
      this.global.banderaModificaionTicket = false;
      this.ruta.navigateByUrl("/user-ticket");
    } else {
      window.localStorage.setItem("informacion beneficiario", JSON.stringify([]));
      this.ruta.navigateByUrl("/crear-ticket");
    }
  }
  crear() {
    this.spinner.show();
    const exMoment = this.global.Id_Usuario + "_" + moment.now();
    // console.log(this.global.Id_Ticket.length > 2 , 'porque llega id vacio??');
    this.idTicket = this.global.Id_Ticket ? this.global.Id_Ticket : exMoment;
    if (this.Evidence == false) {
      try {
        // console.log(this.idTicket);
        setTimeout(() => {
          const idStatuses = this.valorSubMenu3 == "Agendamiento visita" || this.valorSubMenu2 == "Agendamiento visita" ? 8 :
            this.valorMenu1 === "llamada outbound" ? 11 : 1;
          if (this.typePQRS === undefined) {
            // console.log(this.typePQRS, 'etettetetetetetetety')
            this.alerta.descErr("Revise por favor que no hay campos vacíos");
            this.spinner.hide();
          } else {
            this.id_Proyecto = this.global.banderaModificaionTicket ? this.id_Proyecto : this.datosBeneficiario[0][3]
            this.id_Seccional = this.global.banderaModificaionTicket ? this.id_Seccional : this.datosBeneficiario[0][4]
            this.id_Beneficiario = this.global.banderaModificaionTicket ? this.id_Beneficiario : this.datosBeneficiario[0][1]
            //  console.log(this.datosBeneficiario,'kelly pero que monda')
            console.log(idStatuses, 'este es el que acabo de poner');
            const query = "REPLACE INTO db_liwa.Tickets_New (Id_Tickets,Id_Usuario,Id_Proyecto,Id_Seccional,Id_Statuses,Id_Beneficiario,Menu,SubMenu1,SubMenu2,SubMenu3,Description,Creation_Date,Encargado,IsDelete,IsActive,IsArchived,Codigo)" +
              " VALUES ('" +
              this.idTicket +
              "','" +
              this.global.Id_Usuario +
              "','" +
              this.id_Proyecto +
              "','" +
              this.id_Seccional +
              "','" +
              idStatuses +
              "','" +
              this.id_Beneficiario +
              "','" +
              this.valorMenu1 +
              "','" +
              this.valorSubMenu1 +
              "','" +
              this.valorSubMenu2 +
              "','" +
              this.valorSubMenu3 +
              "','" +
              this.descriptionBenefit +
              "', '" +
              // this.typePQRS + '\',\'' +
              moment().format("YYYY-MM-DD HH:mm:ss") +
              "','" +
              "-" +
              "','" +
              0 +
              "','" +
              1 +
              "','" +
              0 +
              "','" +
              this.codigo +
              "');";
            const pdata1 = { option: "insertar3", texto: query };
            console.log(query, ' este es la queryrota??')
            console.log(pdata1, "este es pdata1");
            this.global.consultar(pdata1, (err, response) => {
              console.log('este es el ganador', response)
              if (response == true) {
                let idStatusesUpdate = this.valorMenu1 === "llamada outbound" ? 1 : idStatuses
                console.log('entro', idStatusesUpdate)
                // alertFunctions.UserSuccess();
                const query2 =
                  "REPLACE INTO db_liwa.Update_Tickets (Id_Ticket,Description,Date,Id_Statuses,IsDelete,IsActive)" +
                  " VALUES ('" +
                  this.idTicket +
                  "','" +
                  "PQRS Creada" +
                  "','" +
                  moment().format("YYYY-MM-DD HH:mm:ss") +
                  "','" +
                  idStatusesUpdate +
                  "','" +
                  0 +
                  "','" +
                  1 +
                  "');";
                const pdata2 = { option: "insertar3", texto: query2 };
                this.global.consultar(pdata2, (err2, response2) => {
                  console.log(response2, 'la concha de tu hermana');
                  if (err2 == null && response2 == true) {
                    this.valorMenu1 != "llamada outbound" ? this.eviarSMS() : console.log('llamada outbound por eso no se envia mensaje');
                    // esta era las unicas opciones que permitiamos antes
                    // if((this.valorSubMenu3 == "Agendamiento visita" || this.valorSubMenu2 == "Agendamiento visita") && this.global.idRole!=15){
                    if ((this.valorMenu1 != "Novedad Solucion") && this.global.idRole != 15) {
                      this.spinner.hide()
                      console.log('eeses', this.NombreProyecto,
                        this.NombreSeccional,)
                      Swal.fire({
                        title: '<strong>¿Desea Agendar una visita"?</strong>',
                        icon: "question",
                        showCloseButton: true,
                        showCancelButton: true,
                        focusConfirm: false,
                        confirmButtonColor: "#093579",
                        cancelButtonText: "No, Gracias!!",
                        cancelButtonAriaLabel: "Thumbs up, great!",
                        confirmButtonText: "Si, estoy seguro",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          setTimeout(() => {
                            let data = JSON.parse(
                              window.localStorage.getItem(
                                "informacion beneficiario"
                              )
                            );
                            this.global.withoutTicket = false;
                            this.global.Id_Ticket = this.idTicket;
                            this.global.selectedForVisit = [
                              this.valorMenu1,
                              this.NombreProyecto,
                              this.NombreSeccional,
                              data[0][4],
                              data[0][8],
                              this.descriptionBenefit,
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                              "",
                            ];
                            this.spinner.hide();
                            this.alerta.descValid(
                              "Nueva PQRS creada con éxito"
                            );
                            this.ruta.navigateByUrl("/crear-visita");
                          }, 1000);
                        } else {
                          this.ruta.navigateByUrl("/user-ticket");
                        }
                      });
                    } else {
                      setTimeout(() => {
                        this.spinner.hide();
                        this.alerta.descValid("Nueva PQRS creada con éxito");
                        this.global.banderaModificaionTicket = false;
                        this.global.Id_Ticket = '-'
                        this.ruta.navigateByUrl("/user-ticket");
                      }, 1000);
                    }
                  } else {
                    this.alerta.descErr(
                      "Revise por favor que no hay campos vacíos"
                    );
                    console.log(err, response, "que pasara 33");
                    this.spinner.hide();
                  }
                });
              } else {
                this.alerta.descErr(
                  "Revise por favor que no hay campos vacíos"
                );
                this.spinner.hide();
                console.log(err, response, "que pasara");
              }
            });
          }
        }, 400);

      } catch (error) {
        // console.log('error:', +error);
      }
    } else {
      // this.loadPhoto(this.idTicket);
    }
  }

  crearUnComentario() {
    const pdataComentario = {
      option: 'insertar3',
      texto: `INSERT INTO db_liwa.Comentarios_Tickets (Comentario, Id_Ticket, Id_Usuario)
         VALUES('${this.descriptionBenefit}', '${this.global.Id_Ticket}', '${this.global.Id_Usuario}');`
    }
    this.global.consultar(pdataComentario, (err2, response2) => {
      console.log(response2)
      if (response2 == true) {
        // alertFunctions.UserSuccess();
        const query2 =
          "REPLACE INTO db_liwa.Update_Tickets (Id_Ticket,Description,Date,Id_Statuses,IsDelete,IsActive)" +
          " VALUES ('" +
          this.global.Id_Ticket +
          "','" +
          "Comentario creado por llamada del cliente" +
          "','" +
          moment().format("YYYY-MM-DD HH:mm:ss") +
          "','" +
          13 +
          "','" +
          0 +
          "','" +
          1 +
          "');";
        const pdata2 = { option: "insertar3", texto: query2 };
        this.global.consultar(pdata2, (err2, response2) => {
          this.spinner.hide();
          this.alerta.descValid("Nueva Comentario creado con éxito");
          this.global.banderaModificaionTicket = false;
          this.global.Id_Ticket = '-'
          this.ruta.navigateByUrl("/user-ticket");
        })
      }
    })
  }
  //  BL            A ESTA PETICION HAY QUE ADACTARLA A LA MIGRACION QUE SE LE HISO A LA BASE DE DATOS YA QUE LOS PARAMETROS HAN CAMBIADO
  // enviarcorreo() {
  //   setTimeout(() => {
  //     const pdata9 = {
  //       option: "mail",
  //       ticket: this.idTicket,
  //       Seccional: this.datosBeneficiario[0][64],
  //       descr: this.descriptionBenefit,
  //       type: this.valorMenu1,
  //       contacto:  this.global.UserName,
  //       tel: this.phoneBenefit,
  //       user: this.datosBeneficiario[0][11],
  //       municipio: this.provBenefit,
  //     };
  //     this.global.consultar(pdata9, (err2, response2) => {
  //       // console.log('Datos correo', response2);
  //     });

  //   }, 500);
  // }
  async eviarSMS() {
    const pdata1 = {
      option: "insertar2",
      texto: `SELECT T.Id_Proyecto, T.Id_Seccional,T.Id_Beneficiario,
        (SELECT M.Id_Maintenance FROM db_liwa.Maintenance_new M WHERE M.Id_Ticket = T.Id_Tickets),
        (SELECT M.Id_Technical FROM db_liwa.Maintenance_new M WHERE M.Id_Ticket = T.Id_Tickets),
        (SELECT M.Status FROM db_liwa.Maintenance_new M WHERE M.Id_Ticket = T.Id_Tickets),
        (SELECT S.Name_Status FROM db_liwa.Ticket_Statuses S WHERE S.Id_Statuses = T.Id_Statuses),
        (SELECT B.Telefono FROM db_liwa.AOM B WHERE B.Id = T.Id_Beneficiario)
         FROM db_liwa.Tickets_New T WHERE T.Id_Tickets = '${this.idTicket}';`,
    };
    this.global.consultar(pdata1, (err9, response9) => {
      const pdata9 = {
        'number': '57' + this.datosBeneficiario[0][9],
        'message': `SUNPOWER ESP le informa PQR radicada No. ${this.idTicket}, Fecha maxima de respuesta en (15 Dias habiles )`,
        'type': '1'
      };
      const pdata8 = {
        'number': '57' + "3164946552",
        'message': `SUNPOWER ESP le informa PQR radicada No. ${this.idTicket}, Fecha maxima de respuesta en (15 Dias habiles )`,
        'type': '1'
      };
      const pdata7 = {
        'number': '57' + "3153583711",
        'message': `SUNPOWER ESP le informa PQR radicada No. ${this.idTicket}, Fecha maxima de respuesta en (15 Dias habiles )`,
        'type': '1'
      };
      this.global.consultarSMS(pdata9, (err2, response2) => {
        this.global.consultarSMS(pdata8, (err2, response2) => {
          this.global.consultarSMS(pdata7, (err2, response2) => {
            let query = `REPLACE INTO db_liwa.MensajesAOM (Id_Proyecto,Id_Seccional,Id_Beneficiario,Id_Maintenance,Id_Ticket,Id_User,Id_Tecnico,Numero_Dest,Tipo_Mantenimiento,Tipo_Ticket,ContenidoSMS)
            VALUES ('${response9[0][0]}','${response9[0][1]}','${response9[0][2]}','${response9[0][3]}','${this.idTicket}','${this.global.Id_Usuario}','${response9[0][4]}','${pdata9.number}','${response9[0][5]}','${response9[0][6]}','${pdata9.message}');`;
            const pdata5 = { option: "insertar3", texto: query }
            this.global.consultar(pdata5, (err2, response2) => {
            });
          })
        })
      });
    });
  }
}
